import { render, staticRenderFns } from "./Mapping.vue?vue&type=template&id=94edda90"
import script from "./Mapping.vue?vue&type=script&lang=js"
export * from "./Mapping.vue?vue&type=script&lang=js"
import style0 from "./Mapping.vue?vue&type=style&index=0&id=94edda90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports